import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import Pagination from "../../../../components/Pagination";

const OfferReport = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const [searchTerm, setSearchTerm] = useState("");
  const [offerReport, setOfferReport] = useState([]);
  const [hrNameList, setHRNameList] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [reportList, setReportList] = useState([]);
  const [showModal, SetShowModal] = useState(false);
  const [selectedModalItem, setSelectedModalItem] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const [filterFormData, setFilterData] = useState([
    { label: "HR Name", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Offer Report"));
  }, []);

  const columns = {
    HRName: { text: "HR Name", visible: true },
    OfferLetterSent: {
      text: "Offers",
      align: "center",
      visible: true,
      type: "Modal",
    },
    OfferLetterAccepted: {
      text: "On Board",
      align: "center",
      visible: true,
      type: "Modal",
    },
    OfferLetterRejected: {
      text: "Offer Decline/No Shows",
      align: "center",
      visible: true,
      type: "Modal",
    },
  };
  const defaultColumns = {
    HRName: true,
    OfferLetterSent: true,
    OfferLetterAccepted: true,
    OfferLetterRejected: true,
  };

  const formDatas = [
    { name: "HR Name", type: "Select", options: [...hrNameList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];
  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const [respStatus, setRepStatus] = useState(0);
  const fetchOfferReport = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/3?P_CreatedBy=&P_FromDate=${lastMonthDate}&P_ToDate=${todayDate}`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.offerReport;
        setOfferReport(data);

        // Hr Name List
        const hrList = response?.data?.data?.hrNames.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);

        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    fetchOfferReport();
  }, []);

  const handleGetData = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/3?P_CreatedBy=${filterFormData.find((o) => o.label === "HR Name")
          ? filterFormData.find((o) => o.label === "HR Name").value
          : ""
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data?.offerReport;
        setOfferReport(data);

        // Hr Name List
        const hrList = response?.data?.data?.hrNames.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);

        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reportList.slice(indexOfFirstItem, indexOfLastItem);

  const handleModalColumn = async (columnName, item) => {
    SetShowModal(true);
    setSelectedModalItem(item);

    // Debug filterFormData

    const fromDate = filterFormData.find(
      (field) => field.label === "From Date"
    )?.value;
    const toDate = filterFormData.find(
      (field) => field.label === "To Date"
    )?.value;



    // Debug formatted dates
    const formattedFromDate = moment(fromDate, "DD-MMM-YYYY").format(
      "YYYY-MM-DD"
    );
    const formattedToDate = moment(toDate, "DD-MMM-YYYY").format("YYYY-MM-DD");

    const statusMapping = {
      HRInterviews: 0,
      Schedule: 1264,
      Selected: 1267,
      Rejected: 1266,
      OfferLetterAccepted: 1322,
      OfferLetterRejected: 1323,
      OnBoard: 1318,
    };

    const status = statusMapping[columnName];

    // Debug selected status

    try {
      const response = await GetServiceCaller(
        `${API_URL}viewCandidateDetails/2?P_Status=${status}&P_JobDescriptionID=0&` +
        `P_FromDate=${formattedFromDate}&` +
        `P_ToDate=${formattedToDate}&` +
        `P_recruiterID=${item.HRID}`
      );

      // Debug response
      const ListData = await response?.data?.header;
      setReportList(ListData);
    } catch (error) {
      console.error("Error fetching job:", error);
    }
  };
  const handleEditModalClose = () => {
    SetShowModal(false);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleReset = () => {
    setFilterData([
      { label: "HR Name", value: "" },
      { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    ])


    fetchOfferReport()
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={offerReport}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              handleReset={handleReset}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              isApiStatus={apiStatus}
              isSorting={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
              handleModalColumn={handleModalColumn}
            />
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between">
                <h3 className="heading skill-heading">Candidate Details</h3>
                <span className="me-2">
                  <i className="bi bi-x-lg" onClick={handleEditModalClose}></i>
                </span>
              </div>
              <div className="modal-body">
                <Table striped hover bordered>
                  <thead id="thcolor">
                    <tr rowSpan={2} className="align-middle text-center">
                      <th>Candidate Name</th>
                      <th>Job Title</th>
                      <th>Experience</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.FullName}</td>
                        <td>{item.JobTitle}</td>
                        <td className="text-center">{item.Experience}</td>
                        <td>{item.CandidateStatus}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-end">
                  <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={reportList.length}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OfferReport;
